export default __webpack_public_path__ + "static/media/smileThree.085b39d6.svg";